import { makeStyles } from 'tss-react/mui';

import { alpha } from '@mui/material/styles';

export default makeStyles({ name: 'RedirectLink' })((theme) => ({
    link: {
        textDecoration: 'none',
        color: theme.palette.primary.main,
        transition: 'color 0.2s',
        '&:hover': {
            color: alpha(theme.palette.primary.main, 0.5)
        }
    }
}));
